import createReducer from '../utils/createReducer';
import actions from '../actions/actions';

const initialState = {};

const actionHandlers = {
    [actions.FETCH_INITIAL_DATA_SUCCESS](state, {payload}) {
        const {
            isPmis
        } = payload.response;

        return {
            ...state,
            isPmis
        };
    }
};

export default createReducer(actionHandlers, initialState);


